module.exports = __webpack_public_path__ + "static/media/9.472b9b26.mp4";